import { Container, Flex, Table, Title } from '@mantine/core';
import { ICurrency } from '../../../../../libraries/currencies';
import { EquipCurrencyDenom, EquipDenomination } from '../../../../../libraries/dashboardV2';
import { formatCurrAmount } from '../../../../utils/script';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../client-redux/reducers';
import { Language } from '../../../../languages/languageHandler';

interface DashboardNotesRecyclerTableProps {
  currencyInfo: EquipCurrencyDenom;
  currencyMatch: ICurrency;
}

const DashboardNotesRecyclerTable = ({ currencyInfo, currencyMatch }: DashboardNotesRecyclerTableProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const devDenoms: EquipDenomination[] = currencyInfo.denominations;

  const matchedDenoms = devDenoms
    .map(denom => {
      const denomMatch = currencyMatch.denominations.find(d => d.index === denom.cindex);
      if (!denomMatch) return null;
      return {
        ...denom,
        value: denomMatch.value,
        type: denomMatch.type
      };
    })
    .filter((d): d is EquipDenomination & { value: number; type: number } => d !== null);

  const noteDenoms = matchedDenoms.filter(d => d.type === 2);

  const formatQty = (qty: number | undefined) => (qty === 0 || qty === undefined ? '-' : qty);

  return (
    <Container className="dashboard-table-container">
      <Flex direction="column" align="flex-start" justify="center">
        <Title order={2} className="dashboard-table-title">
          {lang.EQUIPMENT_BILLS_RECYCLE}
        </Title>
      </Flex>
      <Table withRowBorders className="dashboard-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th className="dashboard-table-header">{lang.GLOBAL_DENOMINATION_MIN}</Table.Th>
            <Table.Th className="dashboard-table-header">{lang.GLOBAL_WORKING_CAPITAL_MIN}</Table.Th>
            <Table.Th className="dashboard-table-header quantity">{lang.GLOBAL_QUANTITY_MIN}</Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.Tbody>
          {noteDenoms.map((denom, index) => (
            <Table.Tr key={index}>
              <Table.Td className="dashboard-currency-table-denom" key={`coin-${denom.cindex}`}>
                {formatCurrAmount(denom.value, currencyMatch, true, false)}
              </Table.Td>
              <Table.Td key={`coin-wc-${denom.cindex}`}>{formatQty(denom.qtyWC)}</Table.Td>
              <Table.Td key={`coin-qty-${denom.cindex}`} style={{ textAlign: 'right' }}>
                {formatQty(denom.qtyRecycler)}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Container>
  );
};

export default DashboardNotesRecyclerTable;
